export enum EnumAba {
  dadosBasicos = 0,
  dadosEspecificos = 1,
  midia = 2,
  dadosFiscais = 3,
  custo = 4,
  comercial = 5
}
